import React, { memo, useEffect } from "react";

import { getCloudinaryUrl, LottieAnimation } from "@swiggy-private/core-ui";
import { isEmpty } from "@swiggy-private/js-utils";

import { TOING_PC_TEST_IDS } from "@swiggy-private/cart-test-ids";
import { LottieWrapper } from "../styles";
import type { IToingPriceComparisonBEData } from "../types";

interface IScanningStateProps {
    scanningData?: IToingPriceComparisonBEData["scanning_states_data"];
    onImpression?: VoidFunction;
}

const ScanningState: React.FC<IScanningStateProps> = ({ scanningData, onImpression }) => {
    useEffect(() => {
        onImpression?.();
    }, [onImpression]);

    const lottieUrl = scanningData?.lottie_id;

    if (isEmpty(lottieUrl)) return null;

    return (
        <LottieWrapper data-testid={TOING_PC_TEST_IDS.LOTTIE}>
            <LottieAnimation
                fileName={getCloudinaryUrl(lottieUrl)}
                visible
                playLottie
                playIfVisible={false}
                loop={false}
                autoplay
                backwardSpeed={1}
                forwardSpeed={1}
            />
        </LottieWrapper>
    );
};

export default memo(ScanningState);
